import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const ArrowblockNESW = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path d="M5 19v-7l3 3 6-6-3-3h7v7l-3-3-6 6 3 3H5z" />
  </SvgIcon>
);

export default ArrowblockNESW;
